import {
  CampaignExecutionStatus,
  CampaignRuleType,
  CampaignStatus,
} from '../../../models/campaign/dto/campaign.dto';
import { translate } from '../../../i18n';

export const STATUS_COLORS: Record<CampaignStatus, string> = {
  [CampaignStatus.DRAFT]: 'gray',
  [CampaignStatus.ACTIVE]: 'green',
  [CampaignStatus.PAUSED]: 'yellow',
  [CampaignStatus.ARCHIVED]: 'red',
};

export const EXEC_STATUS_COLORS: Record<CampaignExecutionStatus, string> = {
  [CampaignExecutionStatus.RUNNING]: 'blue',
  [CampaignExecutionStatus.COMPLETED]: 'green',
  [CampaignExecutionStatus.FAILED]: 'red',
};

export const RULE_TYPE_LABELS: Record<CampaignRuleType, string> = {
  [CampaignRuleType.INACTIVE_DAYS]: translate('campaign.rule_inactive_days'),
  [CampaignRuleType.NO_GAME_DAYS]: translate('campaign.rule_no_game_days'),
  [CampaignRuleType.NO_EVENT_DAYS]: translate('campaign.rule_no_event_days'),
};

export const formatDate = (date: string | Date) =>
  new Date(date).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export function formatConversionRate(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}

export function validateCampaignForm(input: {
  name: string;
  notificationTitle: string;
  notificationBody: string;
  rulesCount: number;
  frequency: string;
  runAt?: string;
}, messages: {
  nameRequired: string;
  titleRequired: string;
  bodyRequired: string;
  rulesRequired: string;
  runAtRequired: string;
}): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!input.name.trim()) {
    errors.name = messages.nameRequired;
  }
  if (!input.notificationTitle.trim()) {
    errors.notificationTitle = messages.titleRequired;
  }
  if (!input.notificationBody.trim()) {
    errors.notificationBody = messages.bodyRequired;
  }
  if (input.rulesCount === 0) {
    errors.rules = messages.rulesRequired;
  }
  if (input.frequency === 'ONE_TIME' && !input.runAt) {
    errors.runAt = messages.runAtRequired;
  }

  return errors;
}

export function computeExecutionSummary(executions: Array<{
  sentCount: number;
  failedCount: number;
  openedCount?: number;
  conversionCount?: number;
}>): { totalSent: number; totalFailed: number; totalOpened: number; totalConversions: number } {
  return executions.reduce(
    (acc, exec) => ({
      totalSent: acc.totalSent + exec.sentCount,
      totalFailed: acc.totalFailed + exec.failedCount,
      totalOpened: acc.totalOpened + (exec.openedCount ?? 0),
      totalConversions: acc.totalConversions + (exec.conversionCount ?? 0),
    }),
    { totalSent: 0, totalFailed: 0, totalOpened: 0, totalConversions: 0 },
  );
}
